import type maplibregl from "maplibre-gl";

/**
 * Remove map layers and sources, tolerating an already torn-down map.
 *
 * These run from effect cleanups, which also fire on unmount. By then the map's
 * style may already be gone (e.g. navigating away from the map view), and
 * calling getLayer/removeLayer throws inside maplibre-gl ("getOwnLayer of
 * undefined"), which bubbles to the error boundary and wedges the whole app.
 * Guard every removal so teardown is a no-op once the map is gone.
 */
export function removeMapLayers(
  map: maplibregl.Map | null | undefined,
  layers: string[],
  sources: string[],
): void {
  if (!map) return;
  try {
    for (const id of layers) {
      if (map.getLayer(id)) map.removeLayer(id);
    }
    for (const id of sources) {
      if (map.getSource(id)) map.removeSource(id);
    }
  } catch {
    // Map was removed while unmounting; nothing left to clean up.
  }
}
